'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product9__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.qd;
      break;
    }
    case 1: {
      return $thiz.qe;
      break;
    }
    case 2: {
      return $thiz.qf;
      break;
    }
    case 3: {
      return $thiz.qg;
      break;
    }
    case 4: {
      return $thiz.qh;
      break;
    }
    case 5: {
      return $thiz.qi;
      break;
    }
    case 6: {
      return $thiz.qj;
      break;
    }
    case 7: {
      return $thiz.qk;
      break;
    }
    case 8: {
      return $thiz.ql;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 8)"));
    }
  }
}
export { $f_s_Product9__productElement__I__O as $f_s_Product9__productElement__I__O };
